// extracted by mini-css-extract-plugin
export default {"wrapper":"RoutingDecisionModal_wrapper__YhEfW","header":"RoutingDecisionModal_header__EI36z","title":"RoutingDecisionModal_title__Dqxr2","body":"RoutingDecisionModal_body__ag4Ki"};